import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer'
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer'
import { ICoriolisConfig, getDefaultCoriolisConfig } from './coriolis/ICoriolisConfig'
import deepmerge from 'deepmerge'


export class IrisrawModCoriolis extends IrisModContainer<IrisConfigContainer<ICoriolisConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModCoriolis.createIrisCoriolisConfig)        
    }

    static createIrisrawModCoriolis(datas:IIrisModContainerConstParam) {        
        return new IrisrawModCoriolis(datas)
    }

    static createIrisCoriolisConfig(data:IIrisConfigContainerConstParam) {                
        return new IrisConfigContainer<ICoriolisConfig>(deepmerge( {mod_settings:getDefaultCoriolisConfig()},data))
    }

}
